// AppointmentTabs/History.jsx
import React from "react";
import Classes from "./AppointmentTabs.module.css";

export default function History({ loading, bookings = [], invoices = [] }) {
  const purchases = invoices.length || 0;
  const spent = invoices.reduce((sum, inv) => sum + Number(inv.total || 0), 0);

  const completed = (bookings || []).filter(b => b.status === "completed")
    .sort((a,b) => (a.appointment?.date || '').localeCompare(b.appointment?.date || ''));
  const upcoming = (bookings || []).filter(b => ["upcoming","on_the_way","delayed"].includes(b.status))
    .sort((a,b) => (a.appointment?.date || '').localeCompare(b.appointment?.date || ''));

  const lastDelivery = completed.length ? completed[completed.length-1].appointment?.date : "—";
  const nextDelivery = upcoming.length ? upcoming[0].appointment?.date : "—";

  return (
    <section className={Classes.panel}>
      <h3 className={Classes.title}>Purchase History</h3>
      <div className={Classes.row}><p className={Classes.label}>Purchases</p><p className={`${Classes.value} ${Classes.muted}`}>{purchases}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Spent</p><p className={`${Classes.value} ${Classes.muted}`}>${spent.toFixed(2)}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Last Delivery</p><p className={`${Classes.value} ${Classes.muted}`}>{lastDelivery}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Next Delivery</p><p className={`${Classes.value} ${Classes.muted}`}>{nextDelivery}</p></div>
    </section>
  );
}
